// The shared 32-colour paint palette (Set 19), loaded once. A paint colour is an INDEX
// (0..31) everywhere it matters — that's the one small integer that rides the terrain
// paint layer's wire deltas, a paint-fish's variety, and a block-maker pixel. The hex is
// resolved only at the edges that actually draw: the renderer, the inventory swatch, the
// block-maker editor. Lua sees indices too (engine.paint_terrain takes one).
import PALETTE from "../../data/palette.json" with { type: "json" };

export const PAINT_COLORS = PALETTE.colors;
export const PAINT_COUNT = PAINT_COLORS.length; // 32

// Clamp/normalise anything the wire or a plugin hands us to a real palette index.
export const paintIndex = (i) => ((Math.trunc(i) % PAINT_COUNT) + PAINT_COUNT) % PAINT_COUNT;
export const paintColor = (i) => PAINT_COLORS[paintIndex(i)];
